import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import FileUpload from '../FileUpload';
import useTupvidApi from '../../hooks/useTupvidApi';
import { Button } from 'reactstrap';
import Notification from '../Notification';
import { useTranslation } from '@ibe/components';
import Keys from '../../../../Translations/generated/CharityDataForm.en.json.keys';
import fallback from '../../../../Translations/generated/CharityDataForm.en.json';

type FormValues = { file: File | null; csvType: string };
export type SendResult = { variant: string; text: string | undefined };

const CharityDataForm = () => {
  const [sendResult, setSendResult] = useState<SendResult | null>(null);
  const api = useTupvidApi();
  const initialValues: FormValues = { file: null, csvType: '' };
  const { t } = useTranslation('CharityDataForm', fallback);

  const uploadData = async (values: FormValues) => {
    if (values.file === null) {
      return;
    }
    try {
      await api.uploadData(values.file, values.csvType);
      setSendResult({ variant: 'success', text: t(Keys.successText) });
    } catch (err) {
      const response = await (err as Response).json();
      const text =
        response.message === 'wrong content' ? t(Keys.wrongContentText) : t(Keys.errorText);
      setSendResult({ variant: 'error', text });
    }
  };

  const onSubmit = (values: FormValues) => {
    uploadData(values);
  };

  return (
    <div className="masterdata">
      <div className="masterdata__content">
        <h1 className="mb-4">{t(Keys.headline)}</h1>
        <div style={{ maxWidth: '1200px' }}>
          {sendResult && <Notification {...sendResult} />}
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({ setFieldValue }) => (
              <Form>
                <div>
                  <FileUpload setFieldValue={setFieldValue} />
                </div>
                <fieldset className="mb-3">
                  <h5>{t(Keys.radioButtonsHeadline)}</h5>
                  <div className="form-check">
                    <label className="form-check-label">
                      <Field
                        className="form-check-input"
                        type="radio"
                        name="csvType"
                        value="donors"
                      />
                      {t(Keys.donorsButtonLabel)}
                    </label>
                  </div>
                  <div className="form-check">
                    <label className="form-check-label">
                      <Field
                        className="form-check-input"
                        type="radio"
                        name="csvType"
                        value="projects"
                      />
                      {t(Keys.projectsButtonLabel)}
                    </label>
                  </div>
                </fieldset>
                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px' }}>
                  <Button color="primary" className="button--default mt-3 mb-3">
                    {t(Keys.submitButtonText)}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CharityDataForm;
